import axios from "axios";
import type { InternalAxiosRequestConfig } from "axios";
import { getCurrentStoreConfig } from "../tenant";
import { startLoading, stopLoading } from "../providers/loadingEvents";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    accept: "text/plain",
    "X-Requested-With": "XMLHttpRequest",
  },
});

api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    startLoading();
    const storeId = getCurrentStoreConfig()?.id;
    const token = localStorage.getItem("token");
    
    // ensure headers exists before mutation
    config.headers = config.headers || {};

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (storeId) {
      config.headers.storeId = storeId;
    }

    return config;
  },
  (error) => {
    stopLoading();
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    stopLoading();
    return response;
  },
  (error) => {
    stopLoading();
    return Promise.reject(error);
  }
);
